import api from './api';

export const getDashboard = () =>
  api.get('/api/v1/dashboard').then((r) => r.data.data);
